import { Action } from '../../common/actions/core/action';
import {ApplyChurnSuccessResponse} from "../../common/services/package/package.model";
export class OpenPackageChurnRetentionSuccessAction implements Action {
    constructor(
        public  messageSuccess?:ApplyChurnSuccessResponse
    ){}
}



// WEBPACK FOOTER //
// src/app/packet/package-churn-retention-success-dialog/package-churn-retention-success-dialog.action.ts